module.exports = __webpack_public_path__ + "img/camera.206d78f8.svg";